<template>
  <div v-if="visible" class="context">
    <div class="example card text-center mb-3">
      <div class="card-body">
        {{$t('result.context.context-example')}}
        <b>{{result.example}}</b>
        {{$t('result.context.previous-list')}}
      </div>
    </div>
    <div v-if="$ncsConfig.result.context.documentHeader" class="document-header card mb-3 p-3">
      <ncs-context-document-header :document="result.document" :text="result.match.text"/>
    </div>
    <ul v-if="result.before.length > 0" class="texts-before list-group">
      <li v-for="text in result.before" class="context-text list-group-item">
        <ncs-context-text :document="result.document" :text="text.text" :elements="text.elements"/>
      </li>
    </ul>
    <ul class="texts-text-match list-group my-3">
      <li class="context-text list-group-item bg-light">
        <i class="far fa-fw" :class="{'fa-file': original(result.document), 'fa-copy': !original(result.document)}"
           :title="$t(`result.context.icon.${original(result.document) ? 'original' : 'translation'}`)"></i>
        <ncs-context-text :document="result.document" :text="result.match.text" :elements="result.match.elements"
                          :matches="result.match.matches" :analysis="true"/>
      </li>
      <li v-for="parallel in result.parallel_matches" class="context-text list-group-item">
        <i class="far fa-fw" :class="{'fa-file': original(parallel.document), 'fa-copy': !original(parallel.document)}"
           :title="$t(`result.context.icon.${original(parallel.document) ? 'original' : 'translation'}`)"></i>
        <ncs-context-text :document="parallel.document" :text="parallel.text"
                          :elements="parallel.elements" :analysis="true" :source-text="searchType === 'tokens'"/>
      </li>
    </ul>
    <ul v-if="result.after.length > 0" class="texts-before list-group">
      <li v-for="text in result.after" class="context-text list-group-item">
        <ncs-context-text :document="result.document" :text="text.text" :elements="text.elements"/>
      </li>
    </ul>
  </div>
</template>
<script>
  import {mapState} from 'vuex'
  import Ncs from 'ncs'

  export default {
    extends: Ncs.defaultComponents.NcsContextResult,
    computed: {
      ...mapState({searchType: s => s.api.query.type})
    },
    methods: {
      original(document) {
        return !document.parallel || document.original === null
      }
    }
  }
</script>
<style lang="scss">
  // Display translation/original icon in the same line as context text
  .context-text,
  .context-source-text,
  .context-units-row {
    display: inline;
  }
</style>